import { useMutation, useQuery } from "react-query";
import { TaskEstimationService } from "../api";
import { isEmpty } from "lodash";
const onDefaultError = (error) => {
  toast.error(error.message);
};
export const useAddEstimationHours = (onSuccess, onError = onDefaultError) => {
  return useMutation(TaskEstimationService.addEstimationHours, {
    onSuccess,
    onError
  });
}
export const useGetEstimationHours = (params, onSuccess, onError = onDefaultError) => {
    return useQuery(["getEstimationHours", params], () => TaskEstimationService.getEstimationHours(params), {
    onSuccess,
    onError,
    //enabled: !isEmpty(params.project_id) && !isEmpty(params.project_task_id)
  });
}
export const useUpdateEstimationHoursStatus = (onSuccess, onError = onDefaultError) => {
  return useMutation(TaskEstimationService.updateEstimationHoursStatus, {
    onSuccess,
    onError
  });
}
